import React from "react";
import { Box, Typography, Button } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory, useLocation } from "react-router-dom";

const AccessDeniedPage = () => {
  const history = useHistory();
  const location = useLocation();

  const handleBackToLogin = () => {
    const deniedPath = location.state?.deniedPath || "/AccessDeniedPage";
    const fallbackPath =
      location.state?.fallbackPath ||
      sessionStorage.getItem("lastAccessiblePath") ||
      "/doctor-home";

    const safeFallback =
      fallbackPath && fallbackPath !== deniedPath && fallbackPath !== "/AccessDeniedPage"
        ? fallbackPath
        : "/doctor-home";

    history.replace(safeFallback);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f5f5f5"
      px={2}
    >
      <LockOutlinedIcon sx={{ fontSize: 80, color: "#d32f2f", mb: 2 }} />

      <Typography variant="h4" color="error" gutterBottom>
        Access Denied
      </Typography>

      <Typography variant="body1" color="textSecondary" mb={4} align="center">
        You do not have permission to access this page.
      </Typography>

      <Button
        variant="contained"
        startIcon={<ArrowBackIcon />}
        onClick={handleBackToLogin}
        sx={{
          backgroundColor: "#0d233f",
          "&:hover": { backgroundColor: "#0b1c33" },
        }}
      >
        Back
      </Button>
    </Box>
  );
};

export default AccessDeniedPage;
